import React from "react";
import { useTranslation } from "react-i18next";
import ModalBase from "./ModalBase";

const TermsAcceptanceModal = ({ isOpen, isAccepting, onAccept, onLogout }) => {
    const { t } = useTranslation();

    const sections = [
        {
            title: t("terms.s1Title"),
            paragraphs: [t("terms.s1p1"), t("terms.s1p2")],
        },
        {
            title: t("terms.s2Title"),
            paragraphs: [t("terms.s2p1")],
            bullets: [t("terms.s2b1"), t("terms.s2b2"), t("terms.s2b3")],
            after: [t("terms.s2a1")],
        },
        {
            title: t("terms.s3Title"),
            paragraphs: [t("terms.s3p1"), t("terms.s3p2")],
            bullets: [t("terms.s3b1"), t("terms.s3b2"), t("terms.s3b3"), t("terms.s3b4"), t("terms.s3b5")],
            after: [t("terms.s3a1")],
        },
        {
            title: t("terms.s4Title"),
            paragraphs: [t("terms.s4p1"), t("terms.s4p2"), t("terms.s4p3")],
        },
        {
            title: t("terms.s5Title"),
            paragraphs: [t("terms.s5p1")],
            bullets: [t("terms.s5b1"), t("terms.s5b2"), t("terms.s5b3"), t("terms.s5b4")],
        },
        {
            title: t("terms.s6Title"),
            paragraphs: [t("terms.s6p1")],
        },
        {
            title: t("terms.s7Title"),
            paragraphs: [t("terms.s7p1")],
            bullets: [t("terms.s7b1"), t("terms.s7b2"), t("terms.s7b3"), t("terms.s7b4"), t("terms.s7b5")],
            after: [t("terms.s7a1")],
        },
        {
            title: t("terms.s8Title"),
            paragraphs: [t("terms.s8p1")],
        },
        {
            title: t("terms.s9Title"),
            paragraphs: [t("terms.s9p1")],
        },
    ];

    return (
        <ModalBase
            isOpen={isOpen}
            onClose={onLogout}
            closeOnOutsideClick={false}
            showCloseButton={false}
            size="lg"
            className="flex h-[90dvh] max-h-[90dvh] flex-col"
        >
            <div className="flex min-h-0 flex-col">
                <div className="border-b border-mute-200 pb-4">
                    <h2 className="text-xl text-primary-700">{t("terms.title")}</h2>
                    <p className="mt-2 text-sm text-mute-700">
                        {t("terms.intro")}
                    </p>
                </div>

                <div className="mt-4 min-h-0 flex-1 overflow-y-auto pr-2 text-sm leading-6 text-mute-700">
                    {sections.map((section) => (
                        <section key={section.title} className="mb-5">
                            <h3 className="mb-2 text-base font-bold text-black">{section.title}</h3>
                            {section.paragraphs?.map((paragraph) => (
                                <p key={paragraph} className="mb-2">
                                    {paragraph}
                                </p>
                            ))}
                            {section.bullets && (
                                <ul className="mb-2 list-disc space-y-1 pl-5">
                                    {section.bullets.map((bullet) => (
                                        <li key={bullet}>{bullet}</li>
                                    ))}
                                </ul>
                            )}
                            {section.after?.map((paragraph) => (
                                <p key={paragraph} className="mb-2">
                                    {paragraph}
                                </p>
                            ))}
                        </section>
                    ))}
                </div>

                <div className="mt-5 flex flex-col-reverse gap-3 border-t border-mute-200 pt-4 sm:flex-row sm:justify-end">
                    <button className="btn btn-outline-primary" onClick={onLogout} disabled={isAccepting}>
                        {t("header.logout")}
                    </button>
                    <button className="btn btn-primary" onClick={onAccept} disabled={isAccepting}>
                        {isAccepting ? t("terms.accepting") : t("terms.accept")}
                    </button>
                </div>
            </div>
        </ModalBase>
    );
};

export default TermsAcceptanceModal;
